var AllianzError = (function (window, document) {
    function allianzNoresponse() {
        //This function handle the possible error of the quote request
        $('#allianzResponseError').removeAttr('hidden');
        $("#allianzBtnNext").removeClass('hide');
        $("#btn-insurance-allianz-next").removeAttr('disabled');
        
        $('#allianzResponse').append($('#form-error-allianz'));
    }

    function allianzNotAvailable(){
        //This function handle the error when the billing country is not US
        $("#allianzBtnNext").addClass('hide');
        $("#btn-insurance-allianz-next").addClass('hide');
        $("#allianzResponse").append($('#form-error-allianz'));
        $("#insurance_form").hide("hides");
        FG.Checkout.prototype.bindToSecureTicket();
        FG.Checkout.prototype.bindToInsuranceForm();
    }

    return {
        allianzNoresponse: allianzNoresponse,
        allianzNotAvailable: allianzNotAvailable,
      };
})(window, document);
